import { render } from "./ListaSelecoes.vue?vue&type=template&id=4bf274d3&scoped=true&ts=true"
import script from "./ListaSelecoes.vue?vue&type=script&lang=ts"
export * from "./ListaSelecoes.vue?vue&type=script&lang=ts"

import "./ListaSelecoes.vue?vue&type=style&index=0&id=4bf274d3&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bf274d3"]])

export default __exports__